import { MapViewerNode } from '@3ddv/dvm-internal';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dvmFormatter',
  standalone: true
})
export class DvmFormatterPipe implements PipeTransform {

  /**
   * Pipe para formatear los nodos de dvm en la template
   * Admite un string con el id del nodo y un booleano para indicar si se quieren añadir guiones. 
   * La pipe comienza haciendo un split del string original, para obtener el id de la sección. Posteriormente,
   * se hace un split sobre este valor para obtener el id de la fila y el asiento. Si los hay. 
   * Si encuentra fila y asiento, devuelve un string con el formato 'sección - fila - asiento' o 'sección fila asiento' dependiendo del valor de hyphens.
   * Si no encuentra fila y asiento, devuelve un string con el formato 'sección'.
   * @param value  - string con el id del nodo
   * @param complete - boolean para indicar si se quieren añadir los labels de 'Section', 'Row' y 'Seat'
   * @param reverse - boolean para indicar si se quiere invertir el orden de los labels
   * @param separator - boolean para indicar si se quieren añadir guiones entre los labels
   * @param separatorString - string para indicar el separador entre los labels. Por defecto es ' - '
   * 
   * @example 
   * ```html
   * {{ 'S_C-8-8' | dvmFormatter: true : false : true }}  // devuelve 'Section C - Row 8 - Seat 8'
   * {{ 'S_C-8-8' | dvmFormatter: true : false : false }} // devuelve 'Section C Row 8 Seat 8'
   * {{ 'S_C-8-8' | dvmFormatter: false : false : true }} // devuelve 'C - 8 - 8'
   * ```  
   * @returns 
   */
  transform( value: MapViewerNode['id'] | MapViewerNode['original_id'], complete?: boolean, reverse?: boolean, separator?: boolean, separatorString: string = ' - '): string {

    const splitString: string[]       = value.split('_'),                                                             // 'S_C-8-8' -> ['S', 'C-8-8'] || S_420V -> ['S', '420V']
          section:     string         = splitString[1].split('-')[0] ?? 'error',                                      // 'C-8-8' -> 'C' || '420V' -> '420V'
          row:         string | null  = splitString[1].split('-').length > 1 ? splitString[1].split('-')[1] : null,   // 'C-8-8' -> '8' || '420V' -> null
          seat:        string | null  = row ? splitString[1].split('-')[2] : null;                                    // 'C-8-8' -> '8' || '420V' -> null

    // Si existe fila y asiento
    if (row && seat) {

      return complete ?
        reverse ? 
          [['Section', section], ['Row', row], ['Seat', seat]].map(pairs => pairs.join(' ')).reverse().join(separator ? separatorString : ' ') :   // Si es complete y reverse
          [['Section', section], ['Row', row], ['Seat', seat]].map(pairs => pairs.join(' ')).join(separator ? separatorString : ' ' )             // Si es complete
        : 
        reverse ?
          [section, row, seat].reverse().join(separator ? separatorString : ' ') :                             // Si es reverse y no es complete
          [section, row, seat].join(separator ? separatorString : ' ')                                         // Si no es ni complete ni reverse	       

    }

    // Si no, devolvemos solo la sección
    return complete ?  
      reverse ? 
        ['Section', section].reverse().join(separator ? separatorString : ' ') :  // Si es complete y reverse
        ['Section', section].join(separator ? separatorString : ' ')              // Si es complete
      : section                                                       // Si no es complete ni reverse, devolvemos solo la sección          

  }

}